import { supabaseUpdateUser } from '../../../supabase/supabaseUpdateUser';

const setUserFavorites = async (favorites) => {
  await supabaseUpdateUser({
    rpc: 'bn_update_favorites',
    data: {
      favorites,
    },
  });
};

export { setUserFavorites };
